import {
  Button,
  CloseIcon,
  Input,
  InputPhone,
  Label,
  Skeleton,
  Text,
} from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './profile-button.module.css'

import { ProfileButtonProps } from './profile-button.type'

export const ProfileButton = ({
  data,
  onHandleChange,
  isLoading,
  onClick,
  index,
  errors,
}: ProfileButtonProps) => {
  const { t } = useTranslation('screenAiCenter')

  const onHandleChangeAttribute = (key: string, newValue: string) => {
    onHandleChange({
      ...data,
      [key]: newValue,
    } as ProfileButtonProps['data'])
  }

  if (isLoading) {
    return (
      <div className={styles.core}>
        <div className={styles.header}>
          <Skeleton width="50%" height="1.25rem" />

          <CloseIcon />
        </div>

        <div className={styles.content}>
          <Skeleton width="100%" height="1rem" />
          <Skeleton width="100%" height="1rem" />
          <Skeleton width="100%" height="1rem" />
        </div>
      </div>
    )
  }

  const getErrorMessage = (key: string) => {
    return errors?.[`selectedLeads[${index}]`]?.[key] as string
  }

  return (
    <div className={styles.core}>
      <div className={styles.header}>
        <Text variant="title-medium">
          {t('conversationNewProfileButtonIdentificationLabel{{number}}', {
            number: index + 1,
          })}
        </Text>

        <Button onClick={onClick && onClick} variant="secondary" model="square">
          <CloseIcon />
        </Button>
      </div>

      <div className={styles.content}>
        <div className={styles.field}>
          <Label>{t('conversationNewProfileButtonNameLabel')}: </Label>

          <Input
            value={data?.name}
            onChange={(newValue) => onHandleChangeAttribute('name', newValue)}
            className={styles.input}
            error={getErrorMessage('name')}
          />
        </div>

        <div className={styles.field}>
          <Label>{t('conversationNewProfileButtonEmailLabel')}: </Label>

          <Input
            value={data?.email}
            onChange={(newValue) => onHandleChangeAttribute('email', newValue)}
            className={styles.input}
            error={getErrorMessage('email')}
          />
        </div>

        <div className={styles.field}>
          <Label>{t('conversationNewProfileButtonPhoneLabel')}: </Label>

          <InputPhone
            value={data?.phone}
            onChange={(newValue) => onHandleChangeAttribute('phone', newValue)}
            className={styles.input}
            error={getErrorMessage('phone')}
          />
        </div>
      </div>
    </div>
  )
}
